import { apiSlice } from "./apiSlice";

export const dealsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all Deals list
        getDealsList: builder.query({
            query: (params) => ({
                url: `Deal`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllDeals"],
        }),

        // Create new Deals
        createDeals: builder.mutation({
            query: (body) => ({
                url: `Deal`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllDeals"],
        }),

        getExportDeals: builder.query({
            query: (params) => ({
                url: `Deal`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        // Update Deals
        updateDeals: builder.mutation({
            query: (body) => ({
                url: `Deal`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ['AllDeals']
        }),

        // Delete Deals
        deleteDeals: builder.mutation({
            query: (id) => ({
                url: `Deal/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllDeals']
        }),

    })
})

export const { useLazyGetDealsListQuery, useCreateDealsMutation, useUpdateDealsMutation, useDeleteDealsMutation, useLazyGetExportDealsQuery } = dealsSlice;